import React, { useContext, useEffect, useState } from "react";
import { get, isEmpty } from "lodash";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import {
  faTimes,
  faTrashAlt,
  faExclamationTriangle,
  faPlus,
} from "@fortawesome/pro-light-svg-icons";
import { faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field } from "formik";
import {
  ManagePlanLayout,
  FieldDropSide,
  FieldTextarea,
  DatePicker,
  DeleteWarning,
  SearchableList,
  FieldButtonGroup,
  DayDropdown,
  MultiSelectDropdown,
  LoaderWrapper,
} from "../../../components";
import months from "../../../mocks/months.json";
import {
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  getPathWithParam,
  required,
  usDateFormat,
  transformToMultiselectSave,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  yesNoOptions,
  clearFieldValues,
  toMultiSelectValueById,
  synchronizeCollection,
  getParamsFromQueryString,
} from "../../../utils";
import {
  createPlanStore,
  setManagePlanLocalCache,
  setManagePlanToastInfo,
} from "../../../contexts";
import {
  useDeepEffect,
  useRequest,
  useRouterParams,
  useTableChecboxSelect,
} from "../../../abstracts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getPlanEntryDateClassificationMasterData,
  getClassificationCodes,
  getValidation,
} from "../../../services";

const initialValues = {};

const AdditionalEntryDateClassificationRuleContainer = (props) => {
  const { state, dispatch } = useContext(createPlanStore);
  const { history } = props;
  const {
    flow,
    planId,
    entryDateClassificationIndex,
    additionalEntryDateClassificationId,
  } = useRouterParams();

  const dirtyCheck = getParamsFromQueryString("dirtyCheck");

  const formName = managePlanFormNames.ADDITIONAL_ENTRYDATECLASSIFICATION_RULE;
  const fields = formFields[formName];
  const intEntryDateClassificationIndex = parseInt(
    entryDateClassificationIndex,
    0
  );
  const entryDateClassificationListData = get(state, "entryDateRules", []);
  const [showWarning, setShowWarning] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState([]);
  const [loading, setLoading] = useState(false);
  const planData = get(state, "api.reviewAndPlanDetail", {});
  // const entryDateClassificationRulesFormValues = get(
  //   entryDateClassificationListData,
  //   intEntryDateClassificationIndex,
  //   {}
  // );
  const additionalEntryDateClassificationRulesData = get(
    entryDateClassificationListData,
    "additionalEntryDateRules",
    []
  );
  const formValues = get(
    additionalEntryDateClassificationRulesData,
    additionalEntryDateClassificationId,
    {}
  );
  var otherEntryDates = get(formValues, "otherEntryDates", [
    { ruleId: formValues.id, month: 0, day: 0 },
  ]);

  const entryDate = get(Values, "entryDateRule");

  const additionalEntryDate = get(formValues, "additionalEntryDateRule");
  const [dates, setDates] = useState(otherEntryDates);
  var planYearOtherEntryDates = get(formValues, "planYearOtherEntryDates", [
    { ruleId: formValues.id, month: 0, day: 0 },
  ]);

  const [additionalDates, setAdditionalDates] = useState(
    planYearOtherEntryDates
  );

  const formValuesExcludedClassifications = get(
    formValues,
    "entryDateClassifications",
    []
  );
  const DeleteToastMessage =
    "You are attempting to delete additional entry date classification rule.";
  const DeleteToastMessageHead =
    "Delete Additional Entry Date Classification Rule?";
  const [newFlow, setNewFlow] = useState(flow);
  const handleConfirmClick = () => {
    setShowWarning(false);
    setShowWarning(true);

    var entryData = {
      ...entryDateClassificationListData,
      additionalEntryDateRules: additionalEntryDateClassificationRulesData.map(
        (additionalEntryDateClassification, index) => {
          if (index == parseInt(additionalEntryDateClassificationId)) {
            return { ...additionalEntryDateClassification, isDeleted: true };
          }
          return additionalEntryDateClassification;
        }
      ),
    };
    // var entryData = entryDateClassificationListData.map((item, index) => {
    //   if (index === intEntryDateClassificationIndex) {
    //     let entryDateClassification = {
    //       ...item,
    //       additionalEntryDateRules: additionalEntryDateClassificationRulesData.filter(
    //         (additionalEntryDateClassification, index) =>
    //           index !== parseInt(additionalEntryDateClassificationId)
    //       ),
    //     };
    //     return entryDateClassification;
    //   }
    //   return item;
    // });
    dispatch(
      setManagePlanLocalCache({
        model: "entryDateRules",
        data: entryData,
      })
    );

    history.push(
      getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION,
        pathParam: [FLOW_TYPES.SAVE, planId, entryDateClassificationIndex],
        queryParam: `?dirtyCheck=${dirtyCheck}`,
      })
    );
    dispatch(
      setManagePlanToastInfo({
        showToast: true,
        toastMessage: `Data deleted successfully`,
      })
    );
  };

  const onDeleteClick = () => {
    setShowWarning(true);
  };
  const handleCancelClick = () => {
    setShowWarning(false);
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  const [
    excludedEmployeeClassifications,
    setExcludedEmployeeClassifications,
  ] = useState([]);
  useEffect(() => {
    if (formValues != null) {
      if (!isEmpty(otherEntryDates) && entryDate == 7) {
        if (dates[0]?.month == null) setDates(otherEntryDates);
      }

      if (!isEmpty(planYearOtherEntryDates) && additionalEntryDate == 7) {
        if (additionalDates[0].month == null)
          setAdditionalDates(planYearOtherEntryDates);
      }
    }
  });
  const entryDateClassificationsList = additionalEntryDateClassificationRulesData
    .filter(
      (additionalEntryDateRule) =>
        additionalEntryDateRule.id &&
        additionalEntryDateRule.isDeleted != true &&
        additionalEntryDateRule.id != get(formValues, "id", 0)
    )
    .flatMap((entryDate) => entryDate["entryDateClassifications"])
    .map((e) => e.employeeClassificationCodeId);
  useDeepEffect(() => {
    setDates(otherEntryDates);
  }, [otherEntryDates]);

  useDeepEffect(() => {
    setAdditionalDates(planYearOtherEntryDates);
  }, [planYearOtherEntryDates]);
  useDeepEffect(() => {
    if (!isEmpty(planData)) {
      const data = get(planData, "companyId", 0);
      const excludedClassificationids = [].concat(
        ...AdditionEn.map((_) =>
          _.entryDateClassifications.map((y) => y.employeeClassificationCodeId)
        )
      );
      setLoading(true);
      getClassificationCodes(data)
        .then((response) => {
          setLoading(false);
          setExcludedEmployeeClassifications(
            response
              .filter(
                (e) =>
                  !entryDateClassificationsList.includes(e.id) &&
                  !excludedClassificationids.includes(e.id)
              )
              .map((val) => ({
                label: val.code + "-" + val.classificationName,
                value: val.id,
              }))
          );
        })
        .catch((error) => {
          //Handle Error
        });
    }
  }, [planData]);
  var ClassifiEn =
    entryDateClassificationListData[intEntryDateClassificationIndex];
  var AdditionEn = additionalEntryDateClassificationRulesData.filter(
    (additionalEntryDateClassification, index) =>
      index !== parseInt(additionalEntryDateClassificationId) &&
      additionalEntryDateClassification.isDeleted != true
  );
  const Values = get(state, "entryDateRules.additionalEntryDateRules", {});
  const sourceEnrollmentRulesData = get(Values, "sourceEnrollmentRules", []);
  const entryDateClassi = get(
    state,
    "entryDateRules.additionalEntryDateRules.entryDateClassifications",
    {}
  );

  const mystyle = { fontWeight: 500, fontSize: ".74rem", marginBottom: "7px" };

  const transformToMultiselect = (list, key) => {
    return (list || []).map((value) => ({
      id: entryDateClassi.id || 0,
      [key]: value,
      AdditionalEntryDateRuleId: formValues.id,
    }));
  };
  const buttons = [
    {
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION,
        pathParam: [newFlow, planId, entryDateClassificationIndex],
        queryParam: `?dirtyCheck=${dirtyCheck}`,
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION,
        pathParam: [FLOW_TYPES.SAVE, planId, entryDateClassificationIndex],
      }),
      queryParam: `?dirtyCheck=${dirtyCheck}`,
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => setNewFlow(FLOW_TYPES.SAVE),
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: onDeleteClick,
    },
    // {
    //   label: "Edit",
    //   variant: "primary",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   onClick: () => setNewFlow(FLOW_TYPES.SAVE),
    // },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTrashAlt,
    //   onClick: onDeleteClick,
    // },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];

  const getDataForSave = (values) => {
    const {
      ruleName,
      effectiveStartDate,
      effectiveEndDate,
      exclusionType,
      entryDateOption,
      entryDateClassifications,
      entryDateRule,
      otherDescription,
      planYearOtherEntryDates,
      otherEntryDates,
      prospectiveOrRetrospective,
      isCoincidingApplicable,
      isSwitchToPlanYearHaveDifferentEntryDates,
      additionalEntryDateRule,
      additionalProspectiveOrRetrospective,
      isCoincidingApplicableForAdditional,
      ...rest
    } = values;
    const formatedValues = {
      ...formValues,
      ...rest,
      ruleName: ruleName || undefined,
      entryDateRule: entryDateRule || undefined,
      entryDateRuleType: 2,
      // planId: planId || undefined,
      entryDateOption: entryDateOption,
      effectiveEndDate: effectiveEndDate || undefined,
      effectiveStartDate: effectiveStartDate || undefined,
      otherDescription: otherDescription || undefined,
      prospectiveOrRetrospective: prospectiveOrRetrospective || undefined,
      isCoincidingApplicable: isCoincidingApplicable,
      otherEntryDates: otherEntryDates || dates || undefined,
      planYearOtherEntryDates:
        planYearOtherEntryDates || additionalDates || undefined,
      isSwitchToPlanYearHaveDifferentEntryDates:
        isSwitchToPlanYearHaveDifferentEntryDates || undefined,
      additionalEntryDateRule: additionalEntryDateRule || undefined,
      additionalProspectiveOrRetrospective:
        additionalProspectiveOrRetrospective || undefined,
      isCoincidingApplicableForAdditional: isCoincidingApplicableForAdditional,
      entryDateClassifications: [
        ...transformToMultiselect(
          (values[fields.entryDateClassifications] || []).filter(
            (val) =>
              !get(formValues, fields.entryDateClassifications, [])
                .map((_) => _.employeeClassificationCodeId)
                .includes(val)
          ),
          "employeeClassificationCodeId"
        ),
        ...synchronizeCollection(
          get(formValues, fields.entryDateClassifications, []),
          values[fields.entryDateClassifications],
          "employeeClassificationCodeId"
        ),
      ],
    };
    let transformedData = {};
    if (isEmpty(formValues)) {
      transformedData = {
        ...entryDateClassificationListData,
        additionalEntryDateRules: [
          ...(additionalEntryDateClassificationRulesData || []),
          formatedValues,
        ],
      };
      return transformedData;
    }
    transformedData = {
      ...entryDateClassificationListData,
      additionalEntryDateRules: additionalEntryDateClassificationRulesData.map(
        (addtionEntryDateItem, addtionEntryDateIndex) => {
          if (
            addtionEntryDateIndex ===
            parseInt(additionalEntryDateClassificationId)
          ) {
            return { ...addtionEntryDateItem, ...formatedValues };
          }
          return addtionEntryDateItem;
        }
      ),
    };
    return transformedData;
  };

  const findDuplicates = (list) => {
    let arr = Array(12)
      .fill()
      .map(() => Array(31));
    let duplicateIndices = [];
    list.forEach((element, index) => {
      if (!(element.month && element.day)) return;
      if (arr[element.month][element.day] == 1) duplicateIndices.push(index);
      else arr[element.month][element.day] = 1;
    });
    return duplicateIndices;
  };

  const onFormSubmit = (values) => {
    dispatch(
      setManagePlanLocalCache({
        model: "entryDateRules",
        data: getDataForSave(values),
      })
    );
    history.push(
      getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION,
        pathParam: [newFlow, planId, entryDateClassificationIndex],
        queryParam: `?dirtyCheck=${dirtyCheck}`,
      })
    );
    dispatch(
      setManagePlanToastInfo({
        showToast: true,
        toastMessage: "Data saved successfully",
      })
    );
  };
  const StartDate = get(formValues, `effectiveStartDate`);
  const EndDate = get(formValues, `effectiveEndDate`);
  const isEdit = newFlow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;
  return (
    <Formik
      initialValues={{
        ...initialValues,

        [fields.entryDateClassifications]: formValuesExcludedClassifications?.map(
          (val) => val.employeeClassificationCodeId
        ),
        [fields.ruleName]: get(formValues, fields.ruleName),
        [fields.effectiveStartDate]: StartDate ? new Date(StartDate) : null,
        [fields.effectiveEndDate]: EndDate
          ? new Date(get(formValues, `effectiveEndDate`))
          : null,
        [fields.entryDateOption]: get(formValues, `entryDateOption`, 1),
        [fields.entryDateRule]: get(formValues, fields.entryDateRule),
        [fields.otherDescription]: get(formValues, fields.otherDescription),
        // [fields.otherEntryDates] : dates || {ruleId:formValues.id, month: 0, day: 0 },
        // [fields.planYearOtherEntryDates] : additionalDates || {ruleId:formValues.id, month: 0, day: 0 },
        [fields.prospectiveOrRetrospective]: get(
          formValues,
          fields.prospectiveOrRetrospective
        ),
        [fields.isCoincidingApplicable]: get(
          formValues,
          fields.isCoincidingApplicable
        ),
        [fields.isSwitchToPlanYearHaveDifferentEntryDates]: get(
          formValues,
          `isSwitchToPlanYearHaveDifferentEntryDates`,
          false
        ),
        [fields.additionalProspectiveOrRetrospective]: get(
          formValues,
          fields.additionalProspectiveOrRetrospective
        ),
        [fields.isCoincidingApplicableForAdditional]: get(
          formValues,
          fields.isCoincidingApplicableForAdditional
        ),
        [fields.additionalEntryDateRule]: get(
          formValues,
          fields.additionalEntryDateRule
        ),
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
      validate={(values) => {
        let dateDuplicates = findDuplicates(dates);
        let additionalDateDuplicates = findDuplicates(additionalDates);
        let errors = {};
        dateDuplicates.forEach((i) => {
          errors[`month${i}`] =
            "PL538 : The entered day and month already exists for the plan";
          errors[`day${i}`] = " ";
        });
        additionalDateDuplicates.forEach((i) => {
          errors[`addMonth${i}`] =
            "PL540 : The entered day and month already exists for the plan";
          errors[`addDay${i}`] = " ";
        });
        return errors;
      }}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        setValues,
        values,
        setTouched,
        errors,
        ...rest
      }) => {
        const onDaySelected = (fieldName, value) => {
          setFieldValue(fieldName, value);
        };
        const handleAddClick = (i) => {
          setDates([...dates, { month: null, day: null }]);
        };
        const handleAdd = (i) => {
          setAdditionalDates([...additionalDates, { month: null, day: null }]);
        };
        const handleRemove = (i) => {
          const list = [...additionalDates];
          for (let i = 0; i < list.length; i++) {
            delete errors[`addMonth${i}`];
            delete errors[`addDay${i}`];
          }
          const updatedDates = [
            ...list
              .filter((_) => !_.isDeleted)
              .map((item, index) => {
                if (index === i) {
                  return { ...item, isDeleted: true };
                }
                return item;
              }),
            ...list.filter((_) => _.isDeleted),
          ];
          updatedDates = updatedDates.filter(
            (_) => !(_.ruleId === undefined && _.isDeleted)
          );
          setAdditionalDates(updatedDates);
          setFieldValue(fields.planYearOtherEntryDates, updatedDates);
        };

        const onExclusionRuleChange = (value) => {
          const updatedValues = clearFieldValues({
            values,
            fieldsToClear: [
              fields.hireDateType,
              fields.startHireDate,
              fields.endHireDate,
              fields.entryDateClassifications,
            ],
          });
          setValues({
            ...updatedValues,
            [fields.entryDateOption]: value,
          });
        };

        const onIsDifferentEntryDateChange = (value) => {
          setValues({
            ...clearFieldValues({
              values,
              fieldsToClear: [
                fields.additionalEntryDateRule,
                fields.additionalProspectiveOrRetrospective,
                fields.isCoincidingApplicableForAdditional,
              ],
            }),
            [fields.isSwitchToPlanYearHaveDifferentEntryDates]: value,
          });
          setTouched({
            [fields.additionalEntryDateRule]: false,
          });
        };

        const handleInputChange = (name, value, index) => {
          const list = [...dates.filter((_) => !_.isDeleted)];
          list[index][name] = value;
          if (name === "month") {
            let startDate = list[index]["day"];
            startDate =
              startDate > 28
                ? value === 2
                  ? 28
                  : startDate === 31
                  ? value < 8
                    ? value % 2 !== 0
                      ? 31
                      : 30
                    : value % 2 === 0
                    ? 31
                    : 30
                  : startDate
                : startDate;
            list[index]["day"] = startDate;
          }
          const updatedDates = [...list, ...dates.filter((_) => _.isDeleted)];
          setDates(updatedDates);
          setFieldValue(fields.otherEntryDates, updatedDates);
        };

        const handleInputChange1 = (name, value, index) => {
          const list = [...additionalDates.filter((_) => !_.isDeleted)];
          list[index][name] = value;
          if (name === "month") {
            let startDate = list[index]["day"];
            startDate =
              startDate > 28
                ? value === 2
                  ? 28
                  : startDate === 31
                  ? value < 8
                    ? value % 2 !== 0
                      ? 31
                      : 30
                    : value % 2 === 0
                    ? 31
                    : 30
                  : startDate
                : startDate;
            list[index]["day"] = startDate;
          }
          const updatedDates = [
            ...list,
            ...additionalDates.filter((_) => _.isDeleted),
          ];
          setAdditionalDates(updatedDates);
          setFieldValue(fields.planYearOtherEntryDates, updatedDates);
        };

        const handleRemoveClick = (i) => {
          const list = [...dates];
          for (let i = 0; i < list.length; i++) {
            delete errors[`month${i}`];
            delete errors[`day${i}`];
          }
          //const list1 = list.filter((_, index) => index != i);
          var updatedDates = [
            ...list
              .filter((_) => !_.isDeleted)
              .map((item, index) => {
                if (index === i) {
                  return { ...item, isDeleted: true };
                }
                return item;
              }),
            ...list.filter((_) => _.isDeleted),
          ];
          updatedDates = updatedDates.filter(
            (_) => !(_.ruleId === undefined && _.isDeleted)
          );
          setDates(updatedDates);
          setFieldValue(fields.otherEntryDates, updatedDates);
        };

        return (
          <LoaderWrapper isLoading={loading}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManagePlanLayout
                buttons={buttons}
                pageFlow={newFlow || flow}
                layoutHeader={
                  additionalEntryDateClassificationId &&
                  "Additional Entry Date Rule"
                }
                customBreadCrumbs={[
                  {
                    label: "Entry Date Rule",
                    link: getPathWithParam({
                      path: MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION,
                      pathParam: [flow, planId, entryDateClassificationIndex],
                      queryParam: `?dirtyCheck=${dirtyCheck}`,
                    }),
                  },
                ]}
              >
                <Row>
                  <Col md="7">
                    <Field
                      isRequired
                      name={fields.ruleName}
                      label="Additional Entry Date Description"
                      autoComplete="off"
                      value={values[fields.ruleName]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldTextarea}
                      validate={(value) => {
                        return [undefined, null, ""].includes(value) ||
                          value.trim().length === 0
                          ? "PL751 : Required"
                          : values[fields.ruleName].trim().length > 50
                          ? "PL752 : Entry Date Description length should not Exceed 50 characters"
                          : additionalEntryDateClassificationRulesData
                              .filter(
                                (additionalEntryDateClassification, index) =>
                                  index !==
                                  parseInt(additionalEntryDateClassificationId)
                              )
                              .some((e) => e.ruleName === value.trim())
                          ? "PL753 : Additional Entry Date name should be unique"
                          : undefined;
                      }}
                      size="lg"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md="4">
                    <Field
                      isRequired
                      label="Effective Start Date"
                      name={fields.effectiveStartDate}
                      value={usDateFormat(values[fields.effectiveStartDate])}
                      disabled={isEdit && !isSave}
                      isDatePicker
                      onClear={() =>
                        setFieldValue(fields.effectiveStartDate, null)
                      }
                      popupContent={
                        <DatePicker
                          onDayClick={(value) => {
                            onDaySelected(fields.effectiveStartDate, value);
                          }}
                          value={usDateFormat(
                            values[fields.effectiveStartDate]
                          )}
                        />
                      }
                      validate={(value) => {
                        return [undefined, null, ""].includes(value)
                          ? "PL754 : Required"
                          : undefined;
                      }}
                      component={FieldDropSide}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md="4">
                    <Field
                      isRequired
                      label="Effective End Date"
                      name={fields.effectiveEndDate}
                      value={usDateFormat(values[fields.effectiveEndDate])}
                      disabled={isEdit && !isSave}
                      isDatePicker
                      onClear={() =>
                        setFieldValue(fields.effectiveEndDate, null)
                      }
                      popupContent={
                        <DatePicker
                          onDayClick={(value) => {
                            onDaySelected(fields.effectiveEndDate, value);
                          }}
                          value={usDateFormat(values[fields.effectiveEndDate])}
                        />
                      }
                      validate={(value) => {
                        return [undefined, null, ""].includes(value)
                          ? "PL755 : Required"
                          : value <= values[fields.effectiveStartDate]
                          ? "PL756 : Entry Date Effective End Date should be greater than Entry Date Effective Start Date"
                          : undefined;
                      }}
                      component={FieldDropSide}
                    />
                  </Col>
                </Row>
                <Field
                  isRequired
                  size="md"
                  name={fields.entryDateOption}
                  label={"Additional Entry Date Option"}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.ADDITIONAL_ENTRYDATE_RULES
                  )}
                  selectedValue={values[fields.entryDateOption]}
                  value={values[fields.entryDateOption]}
                  onChange={(value) => onExclusionRuleChange(value)}
                  component={FieldButtonGroup}
                  validate={(value) => {
                    return [undefined, null, ""].includes(value)
                      ? "PL757 : Required"
                      : undefined;
                  }}
                  disabled={isEdit && !isSave}
                />

                <Field
                  size="md"
                  isRequired
                  label="Additional Rule Employee Classifications"
                  name={fields.entryDateClassifications}
                  value={toMultiSelectValueById(
                    values[fields.entryDateClassifications],
                    excludedEmployeeClassifications
                  )}
                  disabled={isEdit && !isSave}
                  isMultiSelect
                  popupContent={
                    <MultiSelectDropdown
                      label="Select Additional Rule Employee Classifications"
                      options={excludedEmployeeClassifications}
                      name={fields.entryDateClassifications}
                      onSelect={(value) =>
                        setFieldValue(fields.entryDateClassifications, value)
                      }
                      value={values[fields.entryDateClassifications]}
                      disabled={isEdit && !isSave}
                    />
                  }
                  validate={() =>
                    isEmpty(values[fields.entryDateClassifications])
                      ? "PL758 : Required"
                      : undefined
                  }
                  component={FieldDropSide}
                />
                <Field
                  name={fields.entryDateRule}
                  label="Additional Entry date"
                  value={values[fields.entryDateRule]}
                  isRequired
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.ENROLLMENT_PLAN_ENTRYDATE
                  )}
                  popupContent={
                    <SearchableList
                      isRadio
                      isNotTypeAhead
                      label="Select a Entry Date"
                      selectedValue={values[fields.entryDateRule]}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.ENROLLMENT_PLAN_ENTRYDATE
                      )}
                      onSelect={(value) => {
                        setFieldValue(fields.entryDateRule, value);
                        //To empty these fields when immediate
                        value == 6 &&
                          setFieldValue(
                            fields.prospectiveOrRetrospective,
                            null
                          );
                        setFieldValue(fields.isCoincidingApplicable, null);

                        value == 7 &&
                          setFieldValue(
                            fields.prospectiveOrRetrospective,
                            null
                          );

                        value != 7 && setFieldValue(fields.otherEntryDates, []);
                        setDates([
                          {
                            ruleId: entryDateClassificationListData.id,
                            month: 0,
                            day: 0,
                          },
                        ]);
                        setFieldValue(fields.otherDescription, null);
                      }}
                    />
                  }
                  dropdownClassName="auto-grow-dropdown"
                  disabled={isEdit && !isSave}
                  component={FieldDropSide}
                  validate={(value) => {
                    return [undefined, null, ""].includes(value)
                      ? "PL759 : Required"
                      : undefined;
                  }}
                />
                {values[fields.entryDateRule] === 7 && (
                  <>
                    <Field
                      name={fields.otherDescription}
                      isRequired
                      label="Other Description"
                      autoComplete="off"
                      value={values[fields.otherDescription]}
                      onChange={handleChange}
                      disabled={isEdit}
                      component={FieldTextarea}
                      size="lg"
                      validate={(value) => {
                        return [undefined, null, ""].includes(value)
                          ? "PL760: Required"
                          : undefined;
                      }}
                    />
                    <div className="small mb-1">{"Other Entry date"}</div>
                    {dates
                      .filter((_) => !_.isDeleted)
                      .map((x, i) => {
                        return (
                          <>
                            <Row>
                              {i == 0 && (
                                <>
                                  <Col md="2">
                                    <div style={mystyle}>{"Month"}</div>
                                  </Col>
                                  <Col md="2">
                                    <div style={mystyle}>{"Day"}</div>
                                  </Col>
                                </>
                              )}
                            </Row>
                            <Row>
                              <Col md="2">
                                <Field
                                  isRequired
                                  key={i}
                                  name={`month${i}`}
                                  //{...rest}
                                  size="sm"
                                  placeholder="Month"
                                  value={x.month}
                                  options={months.data}
                                  disabled={isEdit && !isSave}
                                  popupContent={
                                    <SearchableList
                                      label="Select a month"
                                      isNotTypeAhead
                                      options={months.data}
                                      onSelect={(value) => {
                                        handleInputChange("month", value, i);
                                      }}
                                      selectedValue={x.month}
                                    />
                                  }
                                  component={FieldDropSide}
                                  validate={(value) => {
                                    return [undefined, null, 0, ""].includes(
                                      x.month
                                    )
                                      ? "PL761 : Required"
                                      : undefined;
                                  }}
                                />
                              </Col>
                              <Col md="2">
                                <Field
                                  name={`day${i}`}
                                  key={i}
                                  // {...rest}
                                  size="xs"
                                  placeholder="Date"
                                  isRequired
                                  value={x.day}
                                  disabled={isEdit && !isSave}
                                  popupContent={
                                    <DayDropdown
                                      fromMonthDate={
                                        new Date(2019, x.month - 1 || 0)
                                      }
                                      onSelect={(value) => {
                                        handleInputChange("day", value, i);
                                      }}
                                      value={x.day}
                                    />
                                  }
                                  component={FieldDropSide}
                                  validate={(value) => {
                                    return [undefined, null, 0, ""].includes(
                                      x.day
                                    )
                                      ? "PL762 : Required"
                                      : undefined;
                                  }}
                                />
                              </Col>
                              <Col md="1">
                                {dates.filter((_) => !_.isDeleted).length -
                                  1 ===
                                  i && (
                                  <Button
                                    variant="link"
                                    style={{ marginLeft: "5px" }}
                                    disabled={
                                      isEdit ||
                                      x.month === 0 ||
                                      x.day === 0 ||
                                      x.month === null ||
                                      x.day === null
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faPlus}
                                      color="#212529"
                                      style={{
                                        fontSize: "1.4rem",
                                        color: "#3a3974",
                                        marginLeft: "5px",
                                      }}
                                      onClick={() => handleAddClick(i)}
                                    />
                                  </Button>
                                )}
                              </Col>
                              <Col md="1">
                                {dates.filter((_) => !_.isDeleted).length !==
                                  1 && (
                                  <>
                                    <Button
                                      variant="link"
                                      disabled={isEdit && !isSave}
                                    >
                                      <FontAwesomeIcon
                                        icon={faTrashAlt}
                                        color="#212529"
                                        style={{
                                          fontSize: "1.2rem",
                                          color: "red",
                                          marginLeft: "5px",
                                        }}
                                        onClick={() => handleRemoveClick(i)}
                                      />
                                    </Button>
                                  </>
                                )}
                              </Col>
                            </Row>
                          </>
                        );
                      })}
                  </>
                )}
                {values[fields.entryDateRule] != 6 &&
                  values[fields.entryDateRule] != 7 && (
                    <>
                      <Field
                        name={fields.prospectiveOrRetrospective}
                        label="Prospective / Retrospective criteria"
                        value={values[fields.prospectiveOrRetrospective]}
                        isRequired
                        options={toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.ENROLLMENT_PROSPECTIVEORRETROSPECTIVE
                        )}
                        popupContent={
                          <SearchableList
                            isRadio
                            isNotTypeAhead
                            label="Select a Prospective/Retrospective"
                            selectedValue={
                              values[fields.prospectiveOrRetrospective]
                            }
                            options={toOptionValuesFromMapper(
                              OPTIONS_DATA_MAPPER.ENROLLMENT_PROSPECTIVEORRETROSPECTIVE
                            )}
                            onSelect={(value) => {
                              setFieldValue(
                                fields.prospectiveOrRetrospective,
                                value
                              );
                              value == 3 &&
                                setFieldValue(
                                  fields.isCoincidingApplicable,
                                  null
                                );
                            }}
                          />
                        }
                        dropdownClassName="auto-grow-dropdown"
                        //dropdownClassName="auto-grow-dropdown enrollment-dropdown"
                        disabled={isEdit && !isSave}
                        component={FieldDropSide}
                        validate={(value) => {
                          return [undefined, null, ""].includes(value)
                            ? "PL763 : Required"
                            : undefined;
                        }}
                      />
                      {values[fields.prospectiveOrRetrospective] != 3 ? (
                        <>
                          <Field
                            size="sm"
                            name={fields.isCoincidingApplicable}
                            label={`Is "coinciding with" applicable?`}
                            isRequired
                            options={yesNoOptions}
                            selectedValue={
                              values[fields.isCoincidingApplicable]
                            }
                            value={values[fields.isCoincidingApplicable]}
                            onChange={(value) =>
                              setFieldValue(
                                fields.isCoincidingApplicable,
                                value
                              )
                            }
                            component={FieldButtonGroup}
                            disabled={isEdit && !isSave}
                            validate={(value) => {
                              return [undefined, null, ""].includes(value)
                                ? "PL764 : Required"
                                : undefined;
                            }}
                          />
                        </>
                      ) : null}
                    </>
                  )}
                <Field
                  size="sm"
                  isRequired
                  name={fields.isSwitchToPlanYearHaveDifferentEntryDates}
                  label={`Does "switch to plan year" have different entry dates?`}
                  options={yesNoOptions}
                  selectedValue={
                    values[fields.isSwitchToPlanYearHaveDifferentEntryDates]
                  }
                  value={
                    values[fields.isSwitchToPlanYearHaveDifferentEntryDates]
                  }
                  onChange={onIsDifferentEntryDateChange}
                  component={FieldButtonGroup}
                  disabled={isEdit && !isSave}
                  validate={(value) => {
                    return [undefined, null, ""].includes(value)
                      ? "PL765 : Required"
                      : undefined;
                  }}
                />
                {values[fields.isSwitchToPlanYearHaveDifferentEntryDates] && (
                  <>
                    <Field
                      name={fields.additionalEntryDateRule}
                      label={`"Switch to plan year" entry date`}
                      value={values[fields.additionalEntryDateRule]}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.ENROLLMENT_PLAN_ENTRYDATE
                      )}
                      popupContent={
                        <SearchableList
                          isRadio
                          isNotTypeAhead
                          label="Select an plan year entry date"
                          selectedValue={values[fields.additionalEntryDateRule]}
                          options={toOptionValuesFromMapper(
                            OPTIONS_DATA_MAPPER.ENROLLMENT_PLAN_ENTRYDATE
                          )}
                          onSelect={(value) => {
                            setFieldValue(
                              fields.additionalEntryDateRule,
                              value
                            );

                            value == 6 &&
                              setFieldValue(
                                fields.additionalProspectiveOrRetrospective,
                                null
                              );
                            setFieldValue(
                              fields.isCoincidingApplicableForAdditional,
                              null
                            );

                            value == 7 &&
                              setFieldValue(
                                fields.additionalProspectiveOrRetrospective,
                                null
                              );

                            value != 7 &&
                              setFieldValue(fields.planYearOtherEntryDates, []);
                            setAdditionalDates([
                              { ruleId: formValues.id, month: null, day: null },
                            ]);
                          }}
                        />
                      }
                      isRequired
                      dropdownClassName="auto-grow-dropdown"
                      disabled={isEdit && !isSave}
                      component={FieldDropSide}
                      validate={(value) => {
                        return [undefined, null, ""].includes(value)
                          ? "PL766 : Required"
                          : undefined;
                      }}
                    />
                    {values[fields.additionalEntryDateRule] === 7 && (
                      <>
                        <div className="small mb-1">
                          {`"Switch to plan year" other entry date`}
                        </div>
                        {additionalDates
                          .filter((_) => !_.isDeleted)
                          .map((x, i) => {
                            return (
                              <>
                                <Row>
                                  {i == 0 && (
                                    <>
                                      <Col md="2">
                                        <div style={mystyle}>{"Month"}</div>
                                      </Col>
                                      <Col md="2">
                                        <div style={mystyle}>{"Day"}</div>
                                      </Col>
                                    </>
                                  )}
                                </Row>
                                <Row>
                                  <Col md="2">
                                    <Field
                                      isRequired
                                      name={`addMonth${i}`}
                                      {...rest}
                                      size="sm"
                                      placeholder="Month"
                                      value={x.month}
                                      options={months.data}
                                      disabled={isEdit && !isSave}
                                      popupContent={
                                        <SearchableList
                                          label="Select a month"
                                          isNotTypeAhead
                                          options={months.data}
                                          onSelect={(value) => {
                                            handleInputChange1(
                                              "month",
                                              value,
                                              i
                                            );
                                          }}
                                          selectedValue={x.month}
                                        />
                                      }
                                      component={FieldDropSide}
                                      validate={(value) => {
                                        return [undefined, null, ""].includes(
                                          x.month
                                        )
                                          ? "PL767 : Required"
                                          : undefined;
                                      }}
                                    />
                                  </Col>
                                  <Col md="2">
                                    <Field
                                      name={`addDay${i}`}
                                      {...rest}
                                      size="xs"
                                      placeholder="Date"
                                      isRequired
                                      value={x.day}
                                      disabled={isEdit && !isSave}
                                      popupContent={
                                        <DayDropdown
                                          fromMonthDate={
                                            new Date(2019, x.month - 1 || 0)
                                          }
                                          onSelect={(value) => {
                                            handleInputChange1("day", value, i);
                                          }}
                                          value={x.day}
                                        />
                                      }
                                      component={FieldDropSide}
                                      validate={(value) => {
                                        return [undefined, null, ""].includes(
                                          x.day
                                        )
                                          ? "PL768 : Required"
                                          : undefined;
                                      }}
                                    />
                                  </Col>
                                  <Col md="1">
                                    {additionalDates.filter((_) => !_.isDeleted)
                                      .length -
                                      1 ===
                                      i && (
                                      <Button
                                        variant="link"
                                        style={{ marginLeft: "5px" }}
                                        disabled={
                                          isEdit ||
                                          x.month === 0 ||
                                          x.day === 0 ||
                                          x.month === null ||
                                          x.day === null
                                        }
                                      >
                                        <FontAwesomeIcon
                                          icon={faPlus}
                                          color="#212529"
                                          style={{
                                            fontSize: "1.4rem",
                                            color: "#3a3974",
                                            marginLeft: "5px",
                                          }}
                                          onClick={() => handleAdd(i)}
                                        />
                                      </Button>
                                    )}
                                  </Col>
                                  <Col md="1">
                                    {additionalDates.filter((_) => !_.isDeleted)
                                      .length !== 1 && (
                                      <>
                                        <Button
                                          variant="link"
                                          disabled={isEdit && !isSave}
                                        >
                                          <FontAwesomeIcon
                                            icon={faTrashAlt}
                                            color="#212529"
                                            style={{
                                              fontSize: "1.2rem",
                                              color: "red",
                                              marginLeft: "5px",
                                            }}
                                            onClick={() => handleRemove(i)}
                                          />
                                        </Button>
                                      </>
                                    )}
                                  </Col>
                                </Row>
                              </>
                            );
                          })}
                      </>
                    )}
                    {values[fields.additionalEntryDateRule] != 6 &&
                      values[fields.additionalEntryDateRule] != 7 && (
                        <>
                          <Field
                            name={fields.additionalProspectiveOrRetrospective}
                            label="Prospective / Retrospective criteria"
                            value={
                              values[
                                fields.additionalProspectiveOrRetrospective
                              ]
                            }
                            isRequired
                            options={toOptionValuesFromMapper(
                              OPTIONS_DATA_MAPPER.ENROLLMENT_PROSPECTIVEORRETROSPECTIVE
                            )}
                            popupContent={
                              <SearchableList
                                isRadio
                                isNotTypeAhead
                                label="Select a Prospective/Retrospective"
                                selectedValue={
                                  values[
                                    fields.additionalProspectiveOrRetrospective
                                  ]
                                }
                                options={toOptionValuesFromMapper(
                                  OPTIONS_DATA_MAPPER.ENROLLMENT_PROSPECTIVEORRETROSPECTIVE
                                )}
                                onSelect={(value) => {
                                  setFieldValue(
                                    fields.additionalProspectiveOrRetrospective,
                                    value
                                  );
                                  value == 3 &&
                                    setFieldValue(
                                      fields.isCoincidingApplicableForAdditional,
                                      null
                                    );
                                }}
                              />
                            }
                            dropdownClassName="auto-grow-dropdown"
                            //dropdownClassName="auto-grow-dropdown enrollment-dropdown"
                            disabled={isEdit && !isSave}
                            component={FieldDropSide}
                            validate={(value) => {
                              return [undefined, null, ""].includes(value)
                                ? "PL769 : Required"
                                : undefined;
                            }}
                          />
                          {values[
                            fields.additionalProspectiveOrRetrospective
                          ] != 3 && (
                            <>
                              <Field
                                size="sm"
                                name={
                                  fields.isCoincidingApplicableForAdditional
                                }
                                label={`Is "coinciding with" applicable?`}
                                isRequired
                                options={yesNoOptions}
                                selectedValue={
                                  values[
                                    fields.isCoincidingApplicableForAdditional
                                  ]
                                }
                                value={
                                  values[
                                    fields.isCoincidingApplicableForAdditional
                                  ]
                                }
                                onChange={(value) =>
                                  setFieldValue(
                                    fields.isCoincidingApplicableForAdditional,
                                    value
                                  )
                                }
                                component={FieldButtonGroup}
                                disabled={isEdit && !isSave}
                                validate={(value) => {
                                  return [undefined, null, ""].includes(value)
                                    ? "PL770 : Required"
                                    : undefined;
                                }}
                              />
                            </>
                          )}
                        </>
                      )}
                  </>
                )}

                <DeleteWarning
                  DeleteToastMessageHead={DeleteToastMessageHead}
                  DeleteToastMessage={DeleteToastMessage}
                  showModal={showWarning}
                  handleConfirmClick={handleConfirmClick}
                  handleCancelClick={handleCancelClick}
                />
                <Modal show={showPopup} onHide={handleClose}>
                  <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                    <div className="text-right">
                      <FontAwesomeIcon
                        icon={faTimes}
                        color="#000"
                        onClick={handleClose}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="pd-15">
                        <FontAwesomeIcon
                          icon={faExclamationTriangle}
                          color="#f94f50"
                          size="3x"
                        />
                      </div>
                      <div className="remove-text">
                        {/* <h4>Accept Warning ?</h4> */}
                        <p>{errorMessage}</p>
                        <br />
                        {/* <Button
                        className="remove-btn mr-4"
                        //onClick={onDeleteConfirmClick}
                      >
                        Ok
                      </Button> */}
                        <Button
                          className="cancel-btn"
                          onClick={() => {
                            history.push(
                              getPathWithParam({
                                path:
                                  MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION,
                                pathParam: [
                                  FLOW_TYPES.SAVE,
                                  planId,
                                  entryDateClassificationIndex,
                                ],
                                queryParam: `?dirtyCheck=${dirtyCheck}`,
                              })
                            );
                          }}
                        >
                          Ok
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </ManagePlanLayout>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default AdditionalEntryDateClassificationRuleContainer;
